
import { all, getItem, like, likeMulti, allLikes } from "@/api/vote";
import {items} from "@/utils/data"
const state = {}

const mutations = {}
const actions = {
  all({}, id) {
    return new Promise((resolve, reject) => {
        if (id == "346203790539516113"){
            resolve({data:items()})
        }
          all(id)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
    });
  },
  alllikes({}, id) {
    return new Promise((resolve, reject) => {
      allLikes(id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getItem({}, id) {
    return new Promise((resolve, reject) => {
      getItem(id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  like({}, id) {
    return new Promise((resolve, reject) => {
      like(id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  likeMulti({}, data) {
    return new Promise((resolve, reject) => {
      likeMulti(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/vote.js